import { ExchangeBetType } from "app/types/reportType";
import React from "react";
import StatementExchangeBetsContent from "./components/StatementExchangeBetsContent";
// import "./StatementExchangeBetsGrid.scss";
import StatementExchangeBetsHeader from "./components/StatementExchangeBetsHeader";

const StatementExchangeBetsGrid: React.FC<{
  statementList: ExchangeBetType[];
  finalScores: string;
}> = ({ statementList, finalScores }) => {
  return (
    <div className={"bets-grid-table"}>
      <StatementExchangeBetsHeader />
      <StatementExchangeBetsContent
        statementList={statementList}
        finalScores={finalScores}
      />
    </div>
  );
};
export default StatementExchangeBetsGrid;
